module.exports = __webpack_public_path__ + "img/bg-mew-wallet.f8ae4bde.png";